import React from 'react';
import { LoginCallback } from '@okta/okta-react';
import ErrorRedirect from '../error-redirect/ErrorRedirect';

 
const ImplicitCallback = () => (<LoginCallback errorComponent={ErrorRedirect} />);
 
export default ImplicitCallback;